// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"db3ada1968c963223714","181":"376d4a0a878753ab7d33","182":"1026b78890a3a5e97d59","231":"2dde965f2e6260992c1f"}[chunkId] + ".chunk.js";
};